<template>
  <div class="appointment" v-show="$store.state.showAppointment">
    <modal :show="$store.state.showAppointment" @dismiss="dismiss($event)" class="consultant-dialog">
      <div class="shadow" v-show="isShowDatePicker || isShowTimePicker"></div>
      <div class="modal-wrap">
        <div class="page-caption">
          <h3 class="title">预约借款服务</h3>
        </div>
        <form class="form-horizontal form-custom" novalidate="novalidate" @submit.prevent="loanReservation">
          <div class="form-group">
            <label class="control-label col-xs-4">预约日期：</label>
            <div class="col-xs-8">
              <div class="input-group">
                <input class="form-control" type="text" v-model="selectedDate" ref="selectedDate" autocomplete="off" placeholder="预约日期">
                <div class="input-alias" @click="showDatePicker"></div>
                <datePicker :is-show="isShowDatePicker" @select-date="selectDate" :is-limit="true" :end-year="endYear" :end-month="endMonth" :end-date="endDate" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-xs-4">预约时间：</label>
            <div class="col-xs-8">
              <div class="input-group time-group">
                <div class="start-time">
                  <input class="form-control" type="text" v-model="getStartTime" ref="startTime" autocomplete="off" placeholder="开始时间">
                </div>
                <div class="from-to">--</div>
                <div class="end-time">
                  <input class="form-control" type="text" v-model="getEndTime" ref="endTime" autocomplete="off" placeholder="结束时间">
                </div>
                <div class="input-alias" @click="showTimePicker"></div>
                <timePicker v-if="isShowTimePicker" :is-show="isShowTimePicker" :start-time="setPropsStartTime()" @select-start-time="selectStartTime" @select-end-time="selectEndTime" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-xs-4">联&nbsp;&nbsp;系&nbsp;&nbsp;人：</label>
            <div class="col-xs-8">
              <div class="input-group">
                <input class="form-control" type="text" v-model="person" autocomplete="off" placeholder="联系人">
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="control-label col-xs-4">联系电话：</label>
            <div class="col-xs-8">
              <div class="input-group">
                <input class="form-control" type="tel" v-model="phone" autocomplete="off" placeholder="联系电话">
              </div>
            </div>
          </div>
          <div class="btn-wrap">
            <p class="err-wrap">
              <span>{{errmsg}}</span>&nbsp;</p>
            <p class="text-center" style="font-size:14px;color:#2a9ffa;letter-spacing:1px">我们会在您要求的时间与您联系！</p>
            <button class="btn btn-primary" type="submit">确&nbsp;&nbsp;定</button>
          </div>
        </form>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from '@/components/modal/modal'
import DatePicker from '@/components/picker/date-new'
import TimePicker from '@/components/picker/time'
const MONTHRANGE = 3  // 贷款预约月份限制为距今3个月
export default {
  components: {
    Modal,
    DatePicker,
    TimePicker
  },
  props: {
    // show: {
    //   type: Boolean,
    //   default: false,
    //   required: true
    // },
    // counselorId: {
    //   type: String
    // }
  },
  data () {
    return {
      isShowDatePicker: false,
      isShowTimePicker: false,
      selectedDate: '',
      startTime: null,
      endTime: null,
      endYear: null,
      endMonth: null,
      endDate: null,
      person: '',
      phone: '',
      errmsg: ''
    }
  },
  created () {
    this.endYear = new Date().getFullYear()
    this.endMonth = new Date().getMonth() + 1 + MONTHRANGE
    this.endDate = new Date().getDate()
    if (this.endMonth > 12) {
      this.endYear += Math.floor(this.endMonth / 12)
      this.endMonth = this.endMonth % 12
    }
  },
  computed: {
    getStartTime () {
      return this.startTime && this.startTime + ':00'
    },
    getEndTime () {
      return this.endTime && this.endTime + ':00'
    }
  },
  watch: {
    '$store.state.showAppointment' (val) {
      if (val) {
        this.$nextTick(() => {
          if (window.getDomList && window.placeHolder) {
            window.getDomList('input[placeholder]').forEach((element) => {
              window.placeHolder(element, true)
            })
          }
        })
      }
    },
    selectedDate () {
      this.startTime = null
      this.endTime = null
      if (this.$browser.name === 'IE' && this.$browser.version === '9.0') {
        let oWrapper = this.$refs.startTime.previousElementSibling
        let oWrapper1 = this.$refs.endTime.previousElementSibling
        oWrapper.style.display = 'inline-block'
        oWrapper1.style.display = 'inline-block'
      }
    }
  },
  methods: {
    setPropsStartTime () {
      let startTime = 1
      if (new Date(this.selectedDate).getTime() > new Date().getTime()) {
        return startTime
      }
      if (this.startTime === null) {
        startTime = new Date().getHours()
      } else {
        startTime = this.startTime
      }
      return startTime
    },
    showDatePicker () {
      this.isShowDatePicker = true
    },
    showTimePicker () {
      if (!this.selectedDate) {
        this.errmsg = '请先选择预约日期'
        return
      }
      this.isShowTimePicker = true
    },
    validate () {
      let rules = {
        selectedDate: {
          patterns: [{
            pattern: /^\d{4}[-]\d{2}[-]\d{2}$/,
            msg: '请选择合理的预约日期'
          }],
          required: '请选择预约日期'
        },
        startTime: {
          patterns: [{
            pattern: /\d{1,2}/,
            msg: '请选择合理的开始时间'
          }],
          required: '请选择开始时间'
        },
        endTime: {
          patterns: [{
            pattern: /\d{1,2}/,
            msg: '请选择合理的结束时间'
          }],
          required: '请选择结束时间'
        },
        person: {
          patterns: [{
            pattern: /^\S+$/,
            msg: '请输入正确的联系人名称'
          }],
          required: '请输入联系人'
        },
        phone: {
          patterns: [{
            pattern: this.$validate.patterns.phone,
            msg: '请输入正确的手机号'
          }],
          required: '请输入手机号'
        }
      }
      let msgField = 'errmsg'
      return this.$validate({rules, msgField})
    },
    loanReservation (e) {
      if (this.validate()) {
        let vm = this
        this.$http({
          url: '/loanReservation.jhtml',
          data: {
            contact: this.person,
            counselorId: this.$store.state.counselorId,
            contactNumber: this.phone,
            reservationDate: this.selectedDate,
            startTime: this.startTime,
            endTime: this.endTime
          },
          done () {
            vm.dismiss(e)
            vm.$dialog('预约成功！')
          },
          fail (m) {
            vm.errmsg = m
          }
        })
      }
    },
    dismiss (e) {
      this.isShowDatePicker = false
      this.isShowTimePicker = false
      this.selectedDate = null
      this.startTime = null
      this.endTime = null
      this.person = ''
      this.phone = ''
      this.errmsg = ''
      let oWrapper1 = this.$refs.selectedDate.previousElementSibling
      oWrapper1 && oWrapper1.parentNode.removeChild(oWrapper1)
      let oWrapper2 = this.$refs.startTime.previousElementSibling
      oWrapper2 && oWrapper2.parentNode.removeChild(oWrapper2)
      let oWrapper3 = this.$refs.endTime.previousElementSibling
      oWrapper3 && oWrapper3.parentNode.removeChild(oWrapper3)
      this.$store.commit('toggleAppointment', {show: false})
    },
    selectDate (year, month, date) {
      this.isShowDatePicker = false
      this.selectedDate = year + '-' + month + '-' + date
      if (this.$browser.name === 'IE' && this.$browser.version === '9.0') {
        let oWrapper = this.$refs.selectedDate.previousElementSibling
        oWrapper.style.display = 'none'
      }
    },
    selectStartTime (startTime) {
      this.startTime = startTime
      if (this.$browser.name === 'IE' && this.$browser.version === '9.0') {
        let oWrapper = this.$refs.startTime.previousElementSibling
        oWrapper.style.display = 'none'
      }
    },
    selectEndTime (endTime) {
      this.endTime = endTime
      this.isShowTimePicker = false
      if (this.$browser.name === 'IE' && this.$browser.version === '9.0') {
        let oWrapper = this.$refs.endTime.previousElementSibling
        oWrapper.style.display = 'none'
      }
    }
  }
}
</script>

<style type="text/css" lang="stylus" scoped>
.shadow
  position absolute
  z-index 99
  width 100%
  height 100%
  background-color rgba(255,255,255,0)
.form-custom
  width 454px
.input-alias
  width 100%
  height 100%
  position absolute
  left 0
  top 0
  right 0
  bottom 0
  z-index 10
  background-color rgba(255,255,255,0)
.control-label
  text-align right
.time-group
  line-height 40px
  color #aaa
  .start-time, .end-time
    width 45%
    float left
    height 56px
    input
      text-align center
      padding-right 0 !important
  .from-to
    float left
    width 10%
    height 56px
    line-height 56px
    text-align center
.btn-wrap
  height 100px !important
.err-wrap
  padding 0 40px
</style>



// WEBPACK FOOTER //
// appointment.vue?37f4bdda